import ReactStrapTable from 'components/reactStrapTable';
import React, { useEffect, useState } from 'react'
import EditIcon from 'assets/icon/icon-icon-options-edit.svg';
import ConfigIcon from "assets/icon/config-setting-icon.svg";
import ConfigIconHover from "assets/icon/config-setting-icon-hover.svg";
import EditHoverIcon from 'assets/icon/icon-icon-options-edit_hover.svg';
import HoverImage from 'react-hover-image/build';
import { Button, ButtonGroup, Col, FormGroup, Input, InputGroup, InputGroupText, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import { dateFormate, currencyFormat, cellRendererCheck } from 'utils/columns';
import CancleIcon from 'assets/icon/icon-icon-options-not-eligible.svg';
import Calendar from 'assets/icon/calendar-icon.svg';
import SaveIcon from 'assets/icon/icon-icon-options-order-complete.svg';
import CellEditRender from 'components/reactStrapTable/components/CellEditRender';
import CancleHoverIcon from 'assets/icon/icon-icon-options-not-eligible-hover.svg';
import SaveHoverIcon from 'assets/icon/icon-icon-options-order-complete-hover.svg';
import { Field, Formik } from 'formik';
import ReactSelect from 'react-select';
import FormikDatePicker from 'components/common/Fields/FormikDatePicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import useContextService from 'hooks/useContextService';
import useAxios from 'hooks/useAxios';
import { cloneDeep, find } from "lodash";
import { Option, LimitedChipsContainer } from 'components/Options';
import moment from 'moment';

import reseticon from "assets/icon/reset.svg";
import search from "assets/icon/search.svg";
import cancel from "assets/icon/cancel.svg";
import Loader from 'components/Loader';

let hasDatePopupOpen = false;

let tableDataBackup = [
    {
        chainPharmacy:"123445",
        pharmacy:"123445",
        npi:"123445",
        ncpdPandNABP:"123445",
        pharmacyAddress:"123445",
        pharmacyLiveDate:"123445",
        pharmacyTerminationDate:"123445",
        claimsProcessDate:"123445",

    }
];
let rowForEdit = {};
let updatedFields = {};
let coveredEntityError = "Covered Entity is a required field";
    let accumulationError = "Accumulator is a required field";

    let coveredEntitiesData = [];
    let accumulationData = [];
const SearchContainer = (props) => {
    const {
      onSearch,
      onReset,
       orgId,
       data,
       reset,
        manvalPharmacy,
        loading,
        tabKey,
        setLoading
    } = props;
    
    const [tableData, setTableData] = useState(tableDataBackup);
    // const [data, setData] = useState(tableDataBackup);
    const [showDetails,setShowDetails]=useState(true)
    const [collapseSider, setcollapseSider] = useState(false);
    const [collIcon, setCollIcon] = useState(faAngleUp);
    const [activeButton, setActiveButton] = useState("Left");
    const [modal, setModal] = useState(false);

    const [isSubmited, serIsSubmitted] = useState(false);
    //const [loading, setLoading] = useState(false);

    const [hasACCSelected, setACCSelected] = useState(true);
    const [hasCESelected, setCESelected] = useState(true);
    const [accuDisabled,setAccuDisabled] = useState(false);

    const [selectedCEOption, setCEOptionSelected] = useState({
        optionCESelected: "-1",
      });
      const [selectedACCOption, setOptionACCSelected] = useState({
        optionACCSelected: "-1",
      });
    const API = useAxios();

    const {
        states: { reviewOrder },
        setStates,
        resetStates,
      } = useContextService();
    const { coveredEntity,searchTerms,accumulations } =reviewOrder
    let {
        coveredEntityIDs,
        coveredEntityID,
        accumulationIDs,
        showClaimID,
      } = searchTerms;
      const updateStates = (reviewOrder) => {
        setStates("reviewOrder", reviewOrder);
      };

    // useEffect(()=>{
    //       setModal(false);
    // },[orgId])

      useEffect(() => {
        setCESelected(true);
        setACCSelected(true);   
        setAccuDisabled(false);
        coveredEntitiesData = [];
        accumulationData = [];
        reviewOrder.accumulations = [];
        reviewOrder.searchTerms.coveredEntityIDs = {};
        reviewOrder.searchTerms.accumulationIDs = {};
        updateStates(reviewOrder);
        setCEOptionSelected({optionCESelected:'-1'});
        setOptionACCSelected({optionACCSelected:'-1'});
        fetchCoveredEntities();
        serIsSubmitted(false);
         setModal(false);
      },[orgId, reset]);
      const fetchCoveredEntities = async () => {
        if(tabKey!== "revieworder")return null;
        if (typeof orgId !== "undefined" && orgId !== null) {
            coveredEntitiesData = [];
            reviewOrder.searchTerms.coveredEntityIDs = {};
            updateStates(reviewOrder);

            let selectedOrgId = orgId.organizationID;

            setLoading(true);
            try {
                const { data } = await API.get(`SBConfig/coveredentity/list/${selectedOrgId}`, {
                    hasDefaultURL: true,
                });
                //setLoading(false);
                if (data) {
                    for (var x in data) {
                        coveredEntitiesData.push({ "value": data[x].coveredEntityID, "label": data[x].coveredEntityName });
                    }
                    reviewOrder.coveredEntities = data;

                    if (coveredEntitiesData.length == 1) {
                        var ceData = [];
                        ceData.push(coveredEntitiesData[0])
                        reviewOrder.searchTerms.coveredEntityIDs = ceData;
                        window.selectedCoveredEntittyId = ceData;
                    }
                    if (window.selectedCoveredEntittyId.length > 0) {
                        reviewOrder.searchTerms.coveredEntityIDs = window.selectedCoveredEntittyId;
                    }
                      setLoading(true);

                    updateStates(reviewOrder);
                    if (reviewOrder.searchTerms.coveredEntityIDs) {

                        var ceSelected = [];
                        ceSelected.optionCESelected = [];
                        for (var x in reviewOrder.searchTerms
                          .coveredEntityIDs) {
                          ceSelected.optionCESelected.push(
                            reviewOrder.searchTerms.coveredEntityIDs[x]
                          );
                        }
                        setCEOptionSelected(ceSelected);
                        let ceIds = reviewOrder.searchTerms.coveredEntityIDs.map(item => item["value"]);
                        fetchAccumulatorName(ceIds);
                    }

                }
                  setLoading(false);
            }
            catch (err) {
                setLoading(false);
            }
        }

    };
      const handleCoverdEntityChange = (selectedces, setFieldValue, entity) => {
        let selected = [selectedces == null?[]:selectedces]
        if (selected) {
            window.selectedCoveredEntittyId = selected;
            window.selectedAccumulatorId = [];
            accumulationData = [];
            // setSelectedNdc('');
            reviewOrder.searchTerms.accumulationIDs = {};
            setCESelected(true);
            setCEOptionSelected({
                optionCESelected: selected.value
            });
            let val = selected.value;
            reviewOrder.coveredEntities = selected;
            setFieldValue('coveredEntityIDs', selected);
            reviewOrder.searchTerms.coveredEntityIDs = selected;
            if (Array.isArray(reviewOrder.searchTerms.coveredEntityIDs)) {
                accumulationIDs = {};
                reviewOrder.searchTerms.accumulationIDs = {};
            }
            let ceIds = reviewOrder.searchTerms.coveredEntityIDs.map(item => item["value"]);
            reviewOrder.searchTerms.coveredEntityIDs = ceIds;
            updateStates(reviewOrder);
            setAccuDisabled(false);
            fetchAccumulatorName(ceIds);
            setOptionACCSelected({ optionACCSelected: '-1' });
        }
        else {
            setFieldValue('coveredEntityIDs', {});
            accumulationData = [];
            reviewOrder.coveredEntities = [];
            reviewOrder.searchTerms.coveredEntityIDs = {};
            reviewOrder.searchTerms.accumulationIDs = {};
            setCESelected(false);
            setACCSelected(false);
        }
        updateStates(reviewOrder);
    };
    const showaccountDetails = async () => {
      let acid = searchTerms.accumulationIDs[0].value
      try {
        const { data } = await API.get(`SBTenant/${orgId.tenantID}/PurchaseOrder/ShowAccountDetails/${acid}`,
          { hasDefaultURL: true, }
        )
        
        if (data) {
          setTableData(data);
        }
      }
  
      catch {
  
      }
  
    }
    const fetchAccumulatorName = async (coveredEntityIDs) => {
      debugger
      if (coveredEntityIDs !== undefined && coveredEntityIDs?.length > 0) {
          try {
              accumulationData = [];
              const payload = [];
              payload.AccumulatorEntityList = [coveredEntityIDs[0]];
              let AccumulatorEntityList = [payload.AccumulatorEntityList]
              const result = await API.get(`SBConfig/coveredentity/acclist/${AccumulatorEntityList}`,
                  {
                      hasDefaultURL: true,
                  }
              );
              if (result) {
                  let accumulator = []
                  accumulator = result.data;
                  for (var x in accumulator) {
                      accumulationData.push({ "value": accumulator[x].accumulatorID, "label": accumulator[x].ceName });
                  }
                  if(accumulationData.length == 1){
                      handleAccumulatorname(accumulationData[0]);
                      // var AccData = [];
                      // AccData.push(accumulationData[0])
                      // reviewOrder.searchTerms.accumulationIDs = AccData;
                      // window.selectedAccumulatorId = AccData;
                  }
                  // if(window.selectedAccumulatorId.length > 0){
                  //   reviewOrder.searchTerms.accumulationIDs =
                  //   window.selectedAccumulatorId;
                  //   handleAccumulatorname(window.selectedAccumulatorId[0]);
                  // }

                  reviewOrder.accumulations = result.data;
                  updateStates(reviewOrder);
                  // if (accumulationIDs.length > 0) {
                  //     var accumulatorSelected = {};
                  //     accumulatorSelected.optionACCSelected = [];
                  //     for (var x in accumulationIDs) {
                  //         accumulatorSelected.optionACCSelected.push(accumulationIDs[x]);
                  //     }
                  //     setOptionACCSelected({ accumulatorSelected});
                  // }
              }
          } catch (error) {
              console.log(error.message);
          }
      }
  };
 
      const handleAccumulatorname = (selectedces, setFieldValue, ac) => {
        debugger
        let selected = [selectedces == null?[]:selectedces]
        if (selected) {
          window.selectedAccumulatorId = selected;
            setACCSelected(true);
            setOptionACCSelected({
                optionACCSelected: selected
            })
            // let val = selected.value;
            // setFieldValue('accumulatorID', val);
            // setFieldValue('accumulationIDs', selected);
            setAccuDisabled(true);
            reviewOrder.searchTerms.accumulationIDs = selected;
            handleSubmit();
        }
        else {
            setACCSelected(true);
            setFieldValue('accumulationIDs', {});
            accumulationData = [];
            reviewOrder.coveredEntities = [];
            reviewOrder.searchTerms.accumulationIDs = {};
            reviewOrder.searchTerms.coveredEntityIDs = {};
            setCESelected(false);
        }
        updateStates(reviewOrder);
    };
 

      const handleSubmit = async () => {
        debugger    
        let acIDs = [];
        let ceIDs = [];

        for (var x in searchTerms.accumulationIDs) {
          var rw = searchTerms.accumulationIDs[x];
          acIDs.push(rw.value);
        }

        for (var x in searchTerms.coveredEntityIDs) {
          var rw = searchTerms.coveredEntityIDs[x];
          ceIDs.push(rw.value);
        }

        if (ceIDs.length == 0) {
            setCESelected(false);
            if (acIDs.length == 0) {
                setACCSelected(false);
            }
            //return setSubmitting(false);
            return true;
        }
        if(ceIDs.length > 0 &&acIDs.length == 0){
          setACCSelected(false);
          return true;
        }

        const values = {};
        if (ceIDs > [0]) values.coveredEntityIDs = ceIDs;
        if (acIDs > [0]) values.accumulationIDs = acIDs;
        reviewOrder.search.currentPage = 1;
        updateStates(reviewOrder);
        await onSearch(values);
    };
      
      const handleReset = ({ resetForm }) => {
        serIsSubmitted(false);
        setCESelected(true);
        setACCSelected(true);
        setAccuDisabled(false);
        accumulationData=[];
        window.selectedCoveredEntittyId = "";
        window.selectedAccumulatorId = "";
         resetForm();
        onReset();
        setCEOptionSelected({ optionCESelected: "-1" });
        setOptionACCSelected({ optionACCSelected: "-1" });
        reviewOrder.searchTerms.coveredEntityIDs = {};
        reviewOrder.searchTerms.accumulationIDs = {};
        updateStates(reviewOrder);
        resetStates("reviewOrder");

    }

  const toggle = () => {
    showaccountDetails();
    setModal(!modal);
  }

    const toggleSider = () => {
        setcollapseSider(!collapseSider);
        if (!collapseSider) {
            setCollIcon(faAngleDown);
        }
        else {
            setCollIcon(faAngleUp);
        }
    }

   
    const renderEditButton = () => {
        if (hasPermission('ED'))
            return <Button
                className='text-primary p-0 text-decoration-none'
                color='link'
                onClick={() => ""}
                title='Edit Covered Entity'

            >
                <HoverImage src={EditIcon}
                    hoverSrc={EditHoverIcon}
                    alt='' />
            </Button>
    }
    const cellRenderEdit = (rowData) => {

        if (rowData.isEdit) {
            return (
                <div className='d-flex align-items-center'>
                    <Button
                        className='text-primary p-0 text-decoration-none'
                        color='link'
                        onClick={savePanelUpdateRow}
                    >
                        <HoverImage
                            key='SaveIcon'
                            src={SaveIcon}
                            hoverSrc={SaveHoverIcon}
                            alt=''
                        />
                    </Button>
                    <Button
                        className='text-primary p-0 text-decoration-none'
                        color='link'
                        onClick={() => editRow(rowData, false)}
                    >
                        <HoverImage
                            key='CancelIcon'
                            src={CancleIcon}
                            hoverSrc={CancleHoverIcon}
                            alt=''
                        />
                    </Button>
                </div>
            );
        } else {

            return (
                <div className='d-flex align-items-center'>
                    {renderEditLButton1(rowData)}

                </div>
            );
        }
    };
    const renderEditLButton1 = (rowData) => {
        // if (hasPermission('EPLS'))
            return <Button
                className='text-primary p-0 text-decoration-none'
                color='link'

                onClick={() => editRow(rowData)}
                title='Edit'


            >
                <HoverImage src={EditIcon}
                    hoverSrc={EditHoverIcon}
                    alt='' />
            </Button>
    }
    const editRow = (rowData, isEdit = true) => {

        let tempData = [...data];
        tempData = tempData.map((row) => {
            row.isEdit = false;
            if (row.ceServiceLocationID === rowData?.ceServiceLocationID && isEdit) {
                row.isEdit = isEdit;
                rowForEdit = row;
            }
            return row;
        });
        // setTouched('');
        // setSelectedStatus('');
        updatedFields = {};
        //  tableDataBackup = tempData;
        setData(tempData);
    };
    const savePanelUpdateRow = async () => {
console.log("krishna")
    };
    const updateRowValue = (value, col) => {

        const tempRow = { ...rowForEdit };
        tempRow[col] = value;
        rowForEdit = tempRow;
    };
    const formatter = (row, col, formatterType, alwaysEditableCheckbox) => {

        return (
            <CellEditRender
                row={row}
                col={col}
                formatterType={formatterType}
                onChange={updateRowValue}
                alwaysEditableCheckbox={alwaysEditableCheckbox}
            />
        );
    };

    const handelAdd=()=>{
        setShowDetails(false)
    }
    const handelCancel=()=>{
        setShowDetails(true)
    }
    useEffect(()=>{

    },[showDetails])
    const handleMouseLeave = () => {
        hasDatePopupOpen = false;
    };

    const handleDateClick = (id) => {

        if (hasDatePopupOpen) {
            hasDatePopupOpen = false;
            return;
        }
        const calendarButton = document.getElementById(id);
        if (calendarButton) {
            calendarButton.click();
            hasDatePopupOpen = true;
        }
    };

    const handleButtonClick = (button) => {
      setActiveButton(button);
    };
  return (
    
    <div>

<h5 className="f-16 text-primary font-weight-700">
   Search Review Order
                  </h5>
                  {/* {loading && <Loader></Loader>} */}
        <Formik
                             initialValues={searchTerms}
                             onSubmit={handleSubmit}
                             //validationSchema={validationSchema}
                            //  enableReinitialize={true}
                            children={(props) => {
                                 const { isSubmitting, handleSubmit, resetForm, setFieldValue, errors, touched } = props;
                                return (
                                  <div hidden={collapseSider}>
                                    <div>
                                      <Row sm={5} className="d-flex" style={{}}>
                                        <Col md={3} lg={3} sm={6} xs={6}>
                                          {" "}
                                          <FormGroup>
                                            <Label for="coveredentity">
                                              Covered Entity
                                            </Label>
                                            <ReactSelect
                                              name="coveredentity"
                                              id="coveredentity"
                                              options={coveredEntitiesData}
                                              //isMulti
                                              // closeMenuOnSelect={false}
                                              // isClearable ={true}
                                              // hideSelectedOptions={false}
                                              optionSelected={true}
                                              components={{
                                                Option,
                                              }}
                                              // isSearchable="true"
                                              onChange={(value, entity) =>
                                                handleCoverdEntityChange(
                                                  value,
                                                  setFieldValue,
                                                  entity
                                                )
                                              }
                                              value={
                                                selectedCEOption.optionCESelected
                                              }
                                              className="claim_info required"
                                              maxMenuHeight={220}
                                              styles={{
                                                menu: (provided) => ({
                                                  ...provided,
                                                  zIndex: 99,
                                                }),
                                                option: (provided) => ({
                                                  ...provided,
                                                  display: "flex",
                                                  alignItems: "flex-start",
                                                }),
                                              }}
                                            />
                                            {!hasCESelected ? (
                                              <div className="text-danger f-12 position-absolute">
                                                {coveredEntityError}
                                              </div>
                                            ) : null}
                                          </FormGroup>
                                        </Col>
                                        <Col md={3} lg={3} sm={6} xs={6}>
                                          {" "}
                                          <FormGroup>
                                            <Label for="accumulator">
                                              Accumulator
                                            </Label>
                                            <ReactSelect
                                              name="accumulator"
                                              id="accumulator"
                                              options={accumulationData}
                                              isDisabled={
                                                accumulationData.length == 1
                                              }
                                              //isMulti
                                              // closeMenuOnSelect={false}
                                              // isClearable ={true}
                                              // hideSelectedOptions={false}
                                              // optionSelected={true}
                                              components={{
                                                Option,
                                              }}
                                              onChange={(value, ac) =>
                                                handleAccumulatorname(
                                                  value,
                                                  setFieldValue,
                                                  ac
                                                )
                                              }
                                              value={
                                                selectedACCOption.optionACCSelected
                                              }
                                              isSearchable="true"
                                              className="claim_info required"
                                              maxMenuHeight={220}
                                              styles={{
                                                menu: (provided) => ({
                                                  ...provided,
                                                  zIndex: 99,
                                                }),
                                                option: (provided) => ({
                                                  ...provided,
                                                  display: "flex",
                                                  alignItems: "flex-start",
                                                }),
                                              }}
                                            />
                                            {(!hasCESelected &&
                                              !hasACCSelected) ||
                                            (hasCESelected &&
                                              !hasACCSelected) ? (
                                              <div className="text-danger f-12 position-absolute">
                                                {accumulationError}
                                              </div>
                                            ) : null}
                                            {/* { (isSubmited) ? (
                                  <div className="text-danger f-12 position-absolute">
                                    {accumulationError}
                                  </div>
                                ) : null} */}
                                          </FormGroup>
                                        </Col>
                                        <Col
                                          md={3}
                                          lg={3}
                                          sm={6}
                                          xs={6}
                                          className="mt-4"
                                        >
                                          {" "}
                                          <FormGroup>
                                            <Label for="accumulator"></Label>
                                            <Button
                                              // hidden={isAddPermission}
                                              // disabled={isSubmitting}
                                              color="primary"
                                              className="m-auto"
                                              onClick={toggle}

                                              // disabled={!coveredEntityid}
                                              // hidden={!hasPermission("ADD")}
                                            >
                                              Show Account Details
                                            </Button>
                                          </FormGroup>
                                        </Col>
                                      </Row>
                                    </div>
                                    <Row>
                                      <Col md="3" className="d-flex">
                                        <p className="m-0 f-14 mt-3">
                                          PO Date : &nbsp;{" "}
                                        </p>
                                        <p className="m-0 f-14 font-weight-500 mt-3">
                                          {data.length > 0 &&
                                            moment(data[0].poDate).format(
                                              "MM/DD/YYYY"
                                            )}
                                        </p>
                                      </Col>

                                      <Col md="3" className="d-flex">
                                        <p className="m-0 f-14 mt-3">
                                          Wholesaler : &nbsp;{" "}
                                        </p>
                                        <p className="m-0 f-14 font-weight-500 mt-3">
                                          {data.length > 0 &&
                                            data[0].wholesalerName}
                                        </p>
                                      </Col>
                                      <Col md="3" className="d-flex">
                                        <p className="m-0 f-14 mt-3">
                                          Source PO # : &nbsp;
                                        </p>
                                        <p className="m-0 f-14 font-weight-500 mt-3">
                                          {data.length > 0 && data[0].sourcePO}
                                        </p>
                                      </Col>
                                    </Row>
                                    <div hidden={""}>
                                      <Row
                                        className="d-flex"
                                        style={{ justifyContent: "flex-end" }}
                                      >
                                        <Col md="auto" className="">
                                          <Label>{""}</Label>
                                          <Button
                                            // hidden={isAddPermission}
                                            // disabled={isSubmitting}
                                            color="primary"
                                            className="search ms-3"
                                            onClick={handleSubmit}

                                            // disabled={!coveredEntityid}
                                            // hidden={!hasPermission("ADD")}
                                          >
                                            <span className="right_5">
                                              <img src={search} alt="" />
                                            </span>{" "}
                                            Search
                                          </Button>
                                          <Button
                                            // hidden={isAddPermission}
                                            // disabled={isSubmitting}
                                            color="primary"
                                            className="reset"
                                            onClick={() => handleReset(props)}

                                            // disabled={!coveredEntityid}
                                            // hidden={!hasPermission("ADD")}
                                          >
                                            <span className="right_5">
                                              <img src={reseticon} alt="" />
                                            </span>{" "}
                                            Reset
                                          </Button>
                                        </Col>
                                      </Row>
                                    </div>

                                    {/* <hr /> */}
                                  </div>
                                );
                            }}></Formik>
                             {/* <div className="py-2 text-center">
                            <span style={{ fontSize: "27px", cursor: "pointer", }} onClick={toggleSider}>
                                <FontAwesomeIcon icon={collIcon} className="fa-fw" />
                            </span>
                        </div> */}
                        <Modal isOpen={modal} fade={false} toggle={toggle} className={props.className}>
        <ModalHeader toggle={toggle}><h5 className="f-15 text-primary font-weight-700 mt-2">
        Account Details
    </h5></ModalHeader>
        <ModalBody>
        <table className='show-detals'>
        <thead>
  <tr>
    <th>Account Type</th>
    <th>Acct #</th>
    <th>PO #</th>
  </tr>
  </thead>
  {tableData.map((item) => {
               return (
                <tr
                  key={item.poid}
                  style={{ backgroundColor: "#f2f7fa" }}
                >
                  <td className="flex align-items-center">
                    {item.accountType}
                  </td>
                  <td className="flex align-items-center">
                    {item.accountCode}
                  </td>
                  <td className="flex align-items-center">
                    {item.poid}
                  </td>
                </tr>
              );
              })}
  <tbody>

  </tbody>
  

</table>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" className='reset' onClick={toggle}> <span className="right_5"><img src={cancel} alt="" /></span> Cancel</Button>
        </ModalFooter>
      </Modal>

    </div>
  )
}

export default SearchContainer
